import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

/**
 * "Du bist im Webshop", light, beside the logo — the member portal says the
 * same in dark. One login leads into both, and the person must know at every
 * moment which one they are in (#2282).
 */
export const PlaceLabel = (): ReactElement => (
    <Box
        component="span"
        sx={{
            ml: 1.5,
            px: 1.25,
            py: 0.25,
            borderRadius: '10px',
            fontSize: '11px',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            color: theme => theme.palette.grey[800],
            backgroundColor: theme => theme.palette.grey[100],
            border: theme => `1px solid ${theme.palette.grey[300]}`,
        }}
    >
        <FormattedMessage id="app.topNavigation.youAreInWebshop" />
    </Box>
);
